import { styled } from '@linaria/react'
import { font } from '@reapit/elements/utils/font'

export const MappingTemplateRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  column-gap: 0.75rem;
`

export const MappingTabLayout = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  margin-top: 1rem;
`

export const MappingIntro = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.75rem;
  align-items: stretch;
  max-width: 26rem;
`

export const MappingFieldsPanel = styled.div`
  background-color: white;
  border: 1px solid var(--neutral-100, #e5e9ed);
  border-radius: 0.75rem;
  box-shadow: 0 1px 2px rgba(18, 43, 51, 0.06);
  padding: 1rem 1.25rem;
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
`

/** Fixed-width columns (key / summary / actions) so every row lines up regardless of how long a field's
 * key or mapping summary text is — a flex row with min-width would let long keys push later rows out of
 * alignment with shorter ones. */
export const MappingFieldRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 20rem) minmax(0, 1fr) auto;
  align-items: center;
  column-gap: 0.75rem;
  padding: 0.625rem 0;
  border-bottom: 1px solid var(--neutral-100, #e5e9ed);

  &:last-of-type {
    border-bottom: none;
  }
`

export const MappingFieldKey = styled.span`
  ${font('sm', 'bold')}
  font-family: var(--font-mono, monospace);
  color: var(--colour-text-primary, #222b33);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

/** Wraps the mapping description so a linked-field/merge-token tag can sit alongside plain text. */
export const MappingSummary = styled.div`
  ${font('xs', 'regular')}
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 0.375rem;
  row-gap: 0.25rem;
  color: var(--colour-text-secondary, #607890);
`

/** A dynamic value tag (linked field / merge token) — matches the pills used in the Recipient builder. */
export const MappingSourceTag = styled.span`
  ${font('sm', 'regular')}
  font-family: var(--font-mono, monospace);
  color: var(--colour-text-action, #185fa5);
  background-color: var(--colour-fill-action-lightest, #e6f1fb);
  padding: 0.0625rem 0.4375rem;
  border-radius: 5px;
`

export const MappingSectionHeading = styled.h3`
  ${font('sm', 'bold')}
  color: var(--colour-text-primary, #222b33);
  margin: 0 0 0.25rem;
`

export const MappingCustomLabel = styled.span`
  ${font('xs', 'regular')}
  color: var(--colour-text-secondary, #607890);
  font-style: italic;
`

export const MappingActions = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 0.75rem;
  justify-self: end;
`
